"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fontFamily = `
@font-face {
    font-family:    "montserrat";
    src:            url("/fonts/montserrat/static/Montserrat-Regular.ttf") format('truetype');

}
html {
    font-family: "montserrat", sans-serif;
}
`;
exports.default = {
    fontFamily,
};
